import React, { useEffect, useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import styles from './personal_allysoncavalcante.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5511986487976';
const WHATSAPP_MSG = 'Olá! Gostaria de saber detalhes sobre seu protocolo de treinamento';
const INSTAGRAM_URL = 'https://www.instagram.com/personal_allysoncavalcante?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const EMAIL_ADDRESS = 'allysoncavalcante78@gmail.com';
const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const emailLink = `mailto:${EMAIL_ADDRESS}`;

/** Tempo mínimo na tela: alinhado à animação da barra (~2,1s) + logo */
const LOADER_MIN_MS = 2400;

const loaderAsset = require('./src/loader.png');
const backgroundAsset = require('./src/background-links.png');
const bannerAsset = require('./src/banner-1.png');
const bannerAsset2 = require('./src/banner-2.png');

function preloadImage(src: string): Promise<void> {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => resolve();
        img.src = src;
    });
}

type Personal_allysoncavalcanteLocationState = { skipLoader?: boolean };

const Personal_allysoncavalcante: React.FC = () => {
    const location = useLocation();
    const skipLoader =
        (location.state as Personal_allysoncavalcanteLocationState | null)?.skipLoader === true;

    const [showLoader, setShowLoader] = useState(() => !skipLoader);
    const [loaderExiting, setLoaderExiting] = useState(false);

    useEffect(() => {
        if (!showLoader) return;
        const html = document.documentElement;
        const body = document.body;
        const prevHtmlOverflow = html.style.overflow;
        const prevBodyOverflow = body.style.overflow;
        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        return () => {
            html.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
        };
    }, [showLoader]);

    useEffect(() => {
        if (skipLoader) return;

        let cancelled = false;
        const run = async () => {
            const t0 = performance.now();
            await Promise.all([
                preloadImage(loaderAsset),
                preloadImage(backgroundAsset),
                preloadImage(bannerAsset),
                document.fonts.ready.catch(() => undefined),
            ]);
            const elapsed = performance.now() - t0;
            await new Promise((r) => setTimeout(r, Math.max(0, LOADER_MIN_MS - elapsed)));
            if (cancelled) return;
            setLoaderExiting(true);
            window.setTimeout(() => {
                if (!cancelled) setShowLoader(false);
            }, 560);
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [skipLoader]);

    return (
        <div className={styles.personal_allysoncavalcante} aria-busy={showLoader}>
            {showLoader && (
                <div
                    className={`${styles.loaderOverlay} ${loaderExiting ? styles.loaderOverlayExiting : ''}`}
                    role="status"
                    aria-live="polite"
                    aria-label="Carregando"
                    aria-hidden={loaderExiting}
                >
                    <div className={styles.loaderInner}>
                        <div className={styles.loaderReveal}>
                            <img
                                src={loaderAsset}
                                alt=""
                                className={styles.loaderImage}
                                decoding="async"
                            />
                        </div>
                    </div>
                </div>
            )}
            <div className={styles.page}>
                <div className={styles.hero}>
                    <img
                        src={backgroundAsset}
                        alt="Allyson Cavalcante - Personal trainer"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <div className={styles.statsRow}>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>+5000</span>
                            <span className={styles.statLabel}>Clientes</span>
                        </div>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>+13</span>
                            <span className={styles.statLabel}>Anos de experiência</span>
                        </div>
                    </div>
                    <div className={styles.socialRow}>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="26" color="#fbe286" />
                        </a>
                        <a
                            href={emailLink}
                            className={styles.socialLink}
                            aria-label="E-mail"
                        >
                            <FaEnvelope size={23} color="#fbe286" />
                        </a>
                        <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="WhatsApp"
                        >
                            <WhatsappIcon height="32" color="#fbe286" />
                        </a>
                    </div>

                    <Link to="/personal_allysoncavalcante/consultoria" className={styles.bannerLink}>
                        <img
                            src={bannerAsset}
                            alt="Consultoria fitness online — planos e valores"
                            className={styles.banner}
                        />
                    </Link>
                    <Link to="/personal_allysoncavalcante/antesdepois" className={styles.bannerLink}>
                        <img
                            src={bannerAsset2}
                            alt="Ver antes e depois — resultados de alunos"
                            className={styles.banner}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Personal_allysoncavalcante;
